import step from './step'
import exam from './exam'
export default {step, exam}
